import React from 'react';
import PropTypes from 'prop-types';

export const formatPercentage = (number, precision) => {
  if (!isFinite(number)) return '';
  return `${Number(number).toFixed(precision)}%`;
};
const Percentage = ({ children, precision, automationId }) => (
  <span data-automation-id={automationId}>
    {formatPercentage(children, precision)}
  </span>
);
Percentage.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.number,
    PropTypes.string,
  ]).isRequired,
  precision: PropTypes.number,
  automationId: PropTypes.string,
};
Percentage.defaultProps = {
  precision: 2,
  automationId: null,
};
export default Percentage;
